export default __webpack_public_path__ + "static/media/330_dummy2016-fotograf03-mobile-de.303588e5.png";